import workspaceQuery from '../../../graphql/queries/sales/ToteWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ToteQuery.graphql';
import mutation from '../../../graphql/mutations/sales/ToteUpdateMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ToteFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const Tote: EntityType = {
  type: 'Tote',
  title: 'Totes',
  formTitle: 'Tote',
  formUrl: '/Sales/Picking/Tote/Details/',
  workspaceUrl: '/Sales/Picking/Tote/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  fragment,
  update: mutation,
  screenReference: 'TOTE',
};

export default Tote;
